import { render, staticRenderFns } from "./badgeSlider.vue?vue&type=template&id=1844a8fe&"
import script from "./badgeSlider.vue?vue&type=script&lang=js&"
export * from "./badgeSlider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports